import type { CharacterManifest, PlayableAsset } from "./types";
import type { VisualState } from "../conversation/state-machine";

export function normalizeCharacterManifest(manifest: CharacterManifest): CharacterManifest {
  return {
    ...manifest,
    states: { ...manifest.states }
  };
}

export function getPlayableAsset(
  manifest: CharacterManifest,
  requestedState: string
): PlayableAsset {
  const state = requestedState as VisualState;
  const hasRequestedState = Object.prototype.hasOwnProperty.call(manifest.states, state);
  const requested = manifest.states[state];
  const fallback = hasRequestedState ? undefined : manifest.states[manifest.defaultState];
  const asset = hasPlayableSource(requested) ? requested : fallback;

  if (hasPlayableSource(asset)) {
    return {
      kind: "video",
      src: asset.src,
      fallback: asset.fallback,
      loop: asset.loop
    };
  }

  return {
    kind: "image",
    src: manifest.sourceImage,
    loop: true
  };
}

function hasPlayableSource(
  asset: CharacterManifest["states"][VisualState] | undefined
): asset is NonNullable<CharacterManifest["states"][VisualState]> {
  return Boolean(asset?.src?.trim());
}
